/**
 * Location Edit gallery
 *
 * TODO(mattjs) The gallery needs a model to deal with the timestamp and elided
 * values as well as a controller to deal with gallery wide updates (currently
 * these are in the presentation method)
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.gallery');

goog.require('yext');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.image.Constraints');
goog.require('yext.location.helpers');
goog.require('yext.location.gallery.photo');
goog.require('yext.location.gallery.photo.ui');
goog.require('yext.textfield');

goog.scope(function() {
  const selectorUsage = goog.module.get('yext.dam.assetselector.usage');

  var _gallery = yext.location.gallery;

  /**
   * Initalize gallery module
   * @constructor
   */
  var Gallery = function($element, context, isSuggestEditMode) {
    this.$galleryFields = $element.find('.js-gallery-fields');

    // Grab data
    var data = this.$galleryFields.data('data');

    // Member variables
    this.photos = [];
    this.displayPhotos = [];
    this.data = data;
    this.field = $element.find('input[name="field"]').val();
    this.alwaysShowDestinations = false;
    this.photosInitial_ = [];
    this.reordered_ = false;
    this.elidedMode_ = false;
    this.displayElidedMode_ = false;
    this.elided = 0;
    this.displayElided = 0;
    this.photoCount_ = 0;
    this.contentVaries_ = false;
    this.displayContentVaries_ = false;
    this.orderVaries_ = false;
    this.displayOrderVaries_ = false;
    this.maxImages = this.$galleryFields.find('input[name="maxImages"]').val();
    this.hasGMBSubscription = data.hasGmbSubscription;
    this.assetsOnly = this.$galleryFields.data('assetsOnly');

    // DOM Elements
    this.$element = $element;
    this.$row = $element.closest(context);
    this.$fieldDisplay = $element.find('.gallery-field-display').first();
    this.$fieldEdit = $element.find('.gallery-field-edit');
    this.fieldName = $element.find('input[name=field]').val();
    if (this.fieldName === '') {
      this.fieldName = 'gallery';
    }
    this.customFieldId = this.fieldName.substring(this.fieldName.lastIndexOf('-')+1);
    // Display photo elements
    this.$photoGrid = this.$fieldDisplay.find('.js-photo-grid');
    this.$reorderMessageView = this.$fieldDisplay.find('.js-reorder-message-view');

    // Edit photo elements
    this.$photoList = this.$galleryFields.find('.photo-list');
    this.$editAll = this.$galleryFields.find('.gallery-edit-all');
    this.$editAllCheckbox = this.$galleryFields.find('.gallery-edit-all-checkbox');
    this.$editAllText = this.$galleryFields.find('.js-gallery-edit-all-text');
    this.$specifyDestinations = this.$galleryFields.find('.js-specify-destinations');
    this.$reorderMessageEdit = this.$galleryFields.find('.js-reorder-message-edit');

    this.isSuggestEditMode = isSuggestEditMode;

    // Gallery properties
    if (data) {
      this.destinationsInUse_ = data.destinationsInUse;
      this.timestamp_ = data.timestamp;
      this.contentVaries_ = data.contentVaries;
      this.orderVaries_ = data.orderVaries;
      this.displayOrderVaries_ = data.displayOrderVaries;
      if (data.customFieldId && parseInt(data.customFieldId) !== -1) {
        this.customFieldId = data.customFieldId;
      }

      this.initializePhotos(data.photos, data.displayPhotos, data.destinations);

      if (!data.displayContentVaries) {
        this.renderDisplayMode();
      } else {
        this.displayContentVaries_ = true;
        this.$fieldDisplay.find('.js-various-content-message').show();
      }

      if (data.elidedMode) {
        this.elidedMode_ = true;
        this.elided = data.photoCount;
        this.photoCount_ = data.photoCount;
      }
      if (data.displayElidedMode) {
        this.displayElidedMode_ = true;
        this.displayElided = data.displayPhotoCount;
        this.displayPhotoCount_ = data.displayPhotoCount;
      }
    }
    this.presentation();
    this.bindCancelEdit();
    this.bindEdit();
    this.bindAddPhoto();
    this.setBulkEditCheckbox();
  };

  /**
   * Build the initial photo models and markup
   *
   * @param {!Object} photos Details about initial photos
   * @param {!Object} destinations All of the possible photo destinations and
   * details about that destination including the business' eligibility
   */
  Gallery.prototype.initializePhotos = function(photos, displayPhotos, destinations) {
    yext.location.gallery.photo.ui.init(destinations);

    if (photos) {
      for (var i = 0; i < photos.length; i++) {
        this.newPhoto(photos[i]);
      }
    }

    if (displayPhotos) {
      for (var i = 0; i < displayPhotos.length; i++) {
        this.displayPhotos.push(new yext.location.gallery.photo.model(displayPhotos[i]));
      }
    }

    this.storeInitialPhotoModels();
  };

  /**
   * Create a new photo model and controller
   *
   * @param {!Object} data The initial data used to build the photo model
   */
  Gallery.prototype.newPhoto = function(data) {
    var photo = new yext.location.gallery.photo.model(data);
    this.photos.push(photo);

    // TODO(mattjs) Add logic here based upon permissions
    var $photo = yext.location.gallery.photo.ui.create(this.$element, photo, this.hasGMBSubscription, this.customFieldId);

    this.$photoList.append($photo);

    this.bindEditPhoto($photo);

    var self = this;
    $(photo).on('updated.photo', function() {
      self.broadcast();
    });
    this.presentation();
  };

  /**
   * Stores a copy of the original state of the PhotoModels so that they can be
   * restored
   */
  Gallery.prototype.storeInitialPhotoModels = function() {
    this.photosInitial_ = [];

    for (var i = 0; i < this.photos.length; i++) {
      this.photosInitial_.push({
        model: this.photos[i],
        initial: this.copyProperties(this.photos[i]),
      });
    }
  };

  /**
   * Copy properties from a model that are not on the prototype
   */
  Gallery.prototype.copyProperties = function(model) {
    var copy = {};
    for (var prop in model) {
      if (model.hasOwnProperty(prop)) {
        copy[prop] = model[prop];
      }
    }
    return copy;
  };

  /**
   * Get the stored photo model details
   *
   * @param {Photo} model The model for which to retrieve an initial state
   */
  Gallery.prototype.getInitialPhotoModel = function(model) {
    for (var i = 0; i < this.photosInitial_.length; i++) {
      if (model == this.photosInitial_[i].model) {
        return this.photosInitial_[i].initial;
      }
    }
    return false;
  };

  /**
   * Render the gallery's display mode
   */
  Gallery.prototype.renderDisplayMode = function() {
    var elements = [];
    this.$photoGrid.html('');

    for (var i = 0; i < this.displayPhotos.length; i++) {
      var photo = this.displayPhotos[i];
      var $photo = yext.location.gallery.photo.ui.generateViewMarkup(this.$element, photo, this.hasGMBSubscription);
      elements.push($photo);
      this.bindBrowseGallery($photo.find('.js-gallery-display-photo'));

      // Remove this element if not needed
      if (!this.destinationsInUse_) {
        $photo.find('.js-photo-destinations').remove();
      }
    }
    var empty = !this.displayContentVaries_ && (elements.length === 0 || this.displayElidedMode_);
    this.$fieldDisplay.find('.js-empty-value').toggle(empty);
    this.$fieldDisplay.find('.js-nonempty-value').toggle(!empty);
    this.$fieldDisplay.find('.js-various-content-message').toggle(this.displayContentVaries_);
    this.$reorderMessageEdit.toggle(!this.contentVaries_ && this.orderVaries_);
    this.$reorderMessageView.toggle(!this.displayContentVaries_ && this.displayOrderVaries_);

    this.$photoGrid.append(elements);
  };

  /**
   * Deals with presentation logic pertaining to the gallery as a whole
   */
  Gallery.prototype.presentation = function() {
    if (!this.photos.length || yext.location.gallery.photo.ui.singleDestination()) {
      this.$specifyDestinations.hide();
    } else if (this.destinationsInUse_ || this.alwaysShowDestinations) {
      this.$specifyDestinations.hide();
      yext.location.gallery.photo.ui.resetAll();
    } else {
      this.$specifyDestinations.toggle(!this.destinationsInUse_);
      yext.location.gallery.photo.ui.hideDestinations(this.$photoList.children());
    }
    this.$element.find('.js-add-single-photo').toggle(!this.photos.length);
    if (this.maxImages || this.maxImages == 0) {
      this.$element.find('.js-gallery-add-photo').toggle(this.photos.length < this.maxImages);
    }
  };

  /**
   * Location edit specific features
   *
   * TODO(mattjs) Split the generic portion of the gallery out for use outside
   * of location edit and move to a different file
   *
   * @param {LocationField} locationField
   */
  Gallery.prototype.locationEditFeatures = function(locationField) {
    this.locationField_ = locationField;

    if (this.fieldName.indexOf('custom-photo-') === 0) {
      this.locationField_.saveMessage = yext.msg('Updating photo...');
    } else {
      this.locationField_.saveMessage = yext.msg('Updating gallery...');
    }

    var self = this;
    $(this).on('update.gallery', function() {
      self.locationField_.field.enableSubmit();
    });
    this.onAddPhotoClick();

    this.bindAddOnEditEmpty();
    this.bindFormSubmitCallbacks();
  };

  Gallery.prototype.onAddPhotoClick = function() {
    var self = this;
    this.$element.find('.js-gallery-add-photo,.js-add-single-photo').off('click').on('click', function(e) {
      var $container = $(this).closest('.js-gallery-field-display');

      e.stopPropagation();
      yext.dam.assetselector.show({
        'type': yext.dam.assetselector.types.PHOTO,
        'includeUsedAssets': false,
        'isSuggestedEditMode': self.isSuggestEditMode,
        'hideUploadImageTab': self.assetsOnly,
        'usageType': selectorUsage.forProfileFields(self.field),
      },
      self.field,
      self.customFieldId,
      self.getPhotoConstraints());

      if (self.field == 'location.business_logo') {
        // Transparent backgrounds for logo
        yext.dam.assetselector.photocrop.setFillColor('rgba(255, 255, 255, 0)');
      }

      self.bindAssetSelector();
      $(yext.dam.assetselector.events).on('added.assetselector', function() {
        if (self.locationField_) {
          self.locationField_.toggleEdit(true);
        }
      });
    });
  };

  /*
   * Returns true if the field has an scheduled update
   * and is in a future edit date, false otherwise
   *
   * return {boolean}
   */
  Gallery.prototype.hasScheduledUpdatesField = function() {
    return this.locationField_.hasScheduledUpdates
            && this.locationField_.isFutureEditMode;
  };

  /*
   * Configures the gallery to display the Add Photo dialog when going into edit mode for an empty
   * gallery (and to then cancel the edit mode if no change is made).
   */
  Gallery.prototype.bindAddOnEditEmpty = function() {
    var self = this;
    $(this.locationField_).on('toggleFieldEdit', function(_, editing) {
      if (editing && self.photos.length === 0
          && !self.hasScheduledUpdatesField()) {
        self.showAddPhotoDialog();
        $(yext.dam.assetselector.events).on('closed.assetselector', function onClosed() {
          if (!self.$galleryFields.find('.js-field-error').is(':visible') && self.photos.length === 0) {
            self.locationField_.toggleEdit(false);
          }
          $(yext.dam.assetselector.events).off('closed.assetselector', onClosed);
        });
      }
    });
  };

  /**
   * Displays the Add Photo dialog.
   */
  Gallery.prototype.showAddPhotoDialog = function() {
    yext.dam.assetselector.show({
      'type': 'PHOTO',
      'includeUsedAssets': false,
      'isSuggestEditMode': this.isSuggestEditMode,
      'hideUploadImageTab': this.assetsOnly,
      'usageType': selectorUsage.forProfileFields(this.field),
    }, this.field, this.customFieldId, this.getPhotoConstraints());
    this.bindAssetSelector();
  };

  Gallery.prototype.getPhotoConstraints = function() {
    var constraints = new yext.image.Constraints({
      'container': this.$galleryFields,
    });

    return constraints.get();
  };

  /**
   * Bind the callbacks for when the gallery form is submitted
   */
  Gallery.prototype.bindFormSubmitCallbacks = function() {
    // Prepare the data before the form is submitted
    var self = this;
    this.locationField_.$form.on('beforeSubmit.field', function() {
      var gallery = {};
      gallery.timestamp = self.timestamp_;
      gallery.reordered = self.reordered_;
      gallery.elided = self.elided;
      gallery.orderVaries = self.orderVaries_ && !self.reordered_;
      gallery.displayOrderVaries = self.displayOrderVaries_ && !self.reordered_;

      var uploadIndex = 0;

      for (var i = 0; i < self.photos.length; i++) {
        var model = self.photos[i];

        // New photo
        if (model.asset && model.asset.file) {
          model.asset.fileIndex = uploadIndex++;
          self.locationField_.field.addFile(model.asset.file, model.asset.fileInput);
        }
      }

      gallery.photos = self.photosSerializable();

      self.locationField_.field.additionalData.push({
        name: self.field,
        value: yext.JSON.stringify(gallery),
      });
    });

    this.locationField_.$form.on('save.field', function(e, response) {
      // Exit this block during error
      if (response.error) {
        yext.dam.assetselector.close();
        return;
      }

      // Reset field after suggested edit
      if (!response.field) {
        // Location Edit Field Flow, suggestedEdits should be handled elsewhere now
        self.reset();
        return;
      }

      // Deal with elided mode
      if (!response.field.displayElidedMode) {
        self.displayElidedMode_ = false;
        self.displayElided = 0;
      } else {
        self.displayPhotoCount_ = response.field.displayPhotoCount;
        self.$element.find('.js-num-elided').html(yext.msgn('1 Photo', '{0} Photos', response.field.displayPhotoCount));
      }

      // Update some gallery wide values
      self.timestamp_ = response.field.timestamp;
      self.destinationsInUse_ = response.field.destinationsInUse;
      self.reordered_ = false;
      self.contentVaries_ = response.field.contentVaries;
      self.displayContentVaries_ = response.field.displayContentVaries;
      self.orderVaries_ = response.field.orderVaries;
      self.displayOrderVaries_ = response.field.displayOrderVaries;

      var oldPhotoCount = self.photos.length;

      // Update the photos to match the server response
      self.reconcile(response.field.photos, response.field.displayPhotos);
      self.storeInitialPhotoModels();

      // In the below scenario, the assetselector will be visible even though we don't want it to be
      if (response.stale && oldPhotoCount === 0 && self.photos.length === 1) {
        yext.dam.assetselector.close();
      }

      self.presentation();

      // Clear out any asset objects
      for (var i = 0; i < self.photos.length; i++) {
        delete self.photos[i].asset.file;
        delete self.photos[i].asset.fileInput;
        delete self.photos[i].asset.fileIndex;
        delete self.photos[i].asset.sourceUrl;
      }

      self.$editAllText.html(yext.msgn('1 Photo', '{0} Photos', self.photos.length));

      self.setBulkEditCheckbox();

      if (!self.displayContentVaries_) {
        self.renderDisplayMode();
      } else {
        self.$fieldDisplay.find('.js-various-content-message').show();
      }

      self.locationField_.field.disableSubmit();
    });
  };

  /**
   * Updates photo objects to match the response from the server. This is
   * important for changing the url from a photo that was loaded locally
   * and it ensures that the front end is in sync with the backend
   *
   * @param {!Object} photos Response from location edit
   */
  Gallery.prototype.reconcile = function(photos, displayPhotos) {
    var assets = {};

    // Clear out photos to start fresh
    for (var i = 0; i < this.photos.length; i++) {
      var $photo = yext.location.gallery.photo.ui.getElement(this.photos[i]);
      $photo.find('.js-text-field').each(function() {
        var textField = yext.textfield.get($(this));
        textField.saveValue();
      });

      yext.location.gallery.photo.ui.remove(this.photos[i]);
    }

    this.$photoList.empty();
    this.photos = [];
    this.displayPhotos = [];

    if (photos) {
      for (var i = 0; i < photos.length; i++) {
        photos[i].checked = true;

        if (photos[i].indeterminate) {
          photos[i].checked = undefined;
        }

        this.newPhoto(photos[i]);
      }
    }

    if (displayPhotos) {
      for (var i = 0; i < displayPhotos.length; i++) {
        this.displayPhotos.push(new yext.location.gallery.photo.model(displayPhotos[i]));
      }
    }
  };

  /**
   * Reset gallery to initial state
   */
  Gallery.prototype.bindCancelEdit = function() {
    var self = this;
    this.$fieldEdit.find('.js-cancel-edit').click(function(e) {
      self.reset();
    });
  };

  /**
   * Reset field content
   */
  Gallery.prototype.reset = function() {
    var self = this;
    // Clear out new photos and reset the state of old ones
    for (var i = self.photos.length - 1; i >= 0; i--) {
      var model = self.photos[i];
      var initial = self.getInitialPhotoModel(model);

      if (initial) {
        model.update(initial);
      } else {
        yext.location.gallery.photo.ui.remove(model);
        self.photos.splice(i, 1);
      }
    }

    var photos = [];
    // Reset ordering and show any hidden elements
    for (var i = 0; i < self.photosInitial_.length; i++) {
      var model = self.photosInitial_[i].model;
      var $photo = yext.location.gallery.photo.ui.getElement(model);
      self.$photoList.append($photo.show());
      photos.push(model);
    }

    self.photos = photos;

    if (self.elidedMode_) {
      self.elided = self.photoCount_;
    }

    self.setBulkEditCheckbox();

    self.presentation();

    if (self.locationField_) {
      self.locationField_.field.disableSubmit();
    }
  };

  /**
   * Syncs the bulk edit checkbox with the values of the checks in the photos
   */
  Gallery.prototype.setBulkEditCheckbox = function() {
    if (this.$editAllCheckbox.length) {
      if (this.photos.length) {
        var numberChecked = 0;
        var numberUnchecked = 0;
        var indeterminate = false;

        for (var i = 0; i < this.photos.length; i++) {
          var checked = this.photos[i].checked;
          if (checked === true) {
            numberChecked++;
          } else if (checked === false) {
            numberUnchecked++;
          } else {
            indeterminate = true;
            break;
          }
        }

        var props = {indeterminate: false};

        if (indeterminate) {
          props.checked = false;
          props.indeterminate = true;
        } else if (this.photos.length == numberChecked) {
          props.checked = true;
        } else if (this.photos.length == numberUnchecked) {
          props.checked = false;
        }

        this.$editAllCheckbox.prop(props);
        this.$editAll.show();
      } else {
        this.$editAll.hide();
      }
    }
  };

  /**
   * Couple the gallery to the asset selector 'added' event
   */
  Gallery.prototype.bindAssetSelector = function() {
    var self = this;
    $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
      var isAlreadySelected = false;
      for (var i = 0; i < self.photos.length; i++) {
        if (asset.photoUrl.replace(/^https?\:/, '') == self.photos[i].url.replace(/^https?\:/, '')) {
          isAlreadySelected = true;
          break;
        }
      }

      if (isAlreadySelected) {
        // TRANSLATORS: Error text shown when a user reselects a photo
        yext.location.helpers.showError(yext.msgc('dam', 'This photo has already been selected.'), self.$galleryFields);
      } else {
        yext.location.helpers.hideError(self.$galleryFields);

        var newPhotoData = {
          url: asset.photoUrl,
          asset: asset,
        };

        if (asset.croppedImage) {
          var fileName;

          if (asset.file) {
            fileName = asset.file.name;
          } else {
            fileName = asset.photoUrl;
          }
          newPhotoData['croppedImage'] = asset.croppedImage;
          newPhotoData['croppedImageName'] = fileName;
        }

        self.newPhoto(newPhotoData);

        self.presentation();
        self.broadcast();
      }
    });
  };

  /**
   * 'Add photo' links
   *
   * Bind click events to show the add photo dialog
   */
  Gallery.prototype.bindAddPhoto = function() {
    var self = this;
    this.$galleryFields.find('.js-gallery-add-photo,.js-add-single-photo').on('click', function() {
      yext.dam.assetselector.show({
        'type': yext.dam.assetselector.types.PHOTO,
        'includeUsedAssets': false,
        'isSuggestEditMode': self.isSuggestEditMode,
        'usageType': selectorUsage.forProfileFields(self.field),
      },
      self.field,
      self.customFieldId,
      self.getPhotoConstraints());
      self.bindAssetSelector();
    });
  };

  /**
   * Make updates when the gallery is reordered. Must look at the DOM to get
   * correct photo order
   */
  Gallery.prototype.reordered = function() {
    this.reordered_ = true;
    this.locationField_ && this.locationField_.field.enableSubmit();

    this.$reorderMessageView.hide();
    this.$reorderMessageEdit.hide();

    var self = this;
    var photos = [];
    this.$photoList.children('li').each(function() {
      var photo = yext.location.gallery.photo.ui.getModel($(this));
      if (photo && self.photos.indexOf(photo) != -1) {
        photos.push(photo);
      }
    });

    this.photos = photos;
  };

  /**
   * Bind the general edit events
   */
  Gallery.prototype.bindEdit = function() {
    var self = this;
    this.$photoList.sortable({
      cancel: 'input,textarea,button,select,option,.js-text-field,.js-photo-destinations,.js-pd-indeterminate-message',
      axis: 'y',
      stop: function(e, ui) {
        self.reordered();
        // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
        // image to be misaligned the next time it gets dragged. Explicitly
        // set top/left to auto to fix this.
        ui.item
          .css('top', 'auto')
          .css('left', 'auto');
      },
      containment: this.$galleryFields,
      tolerance: 'pointer',
    });

    this.$editAllCheckbox.change(function() {
      self.$photoList
        .find('input[type="checkbox"]')
        .prop({
          indeterminate: false,
          checked: self.$editAllCheckbox.prop('checked'),
        }).trigger('change');
    });

    this.$fieldEdit.on('click', '.photo-elided .remove-item', function() {
      self.elided = 0;
      $(this).parents('.photo-elided').remove();
      self.broadcast();
    });

    this.$fieldEdit.on('click', 'input[type="checkbox"]', function() {
      self.broadcast();
    });

    this.$specifyDestinations.on('click', function() {
      self.$photoList.find('.js-photo-destinations').show();
      self.$specifyDestinations.hide();
    });
  };

  /**
   * Bind all edit events to a particular photo element
   *
   * @param {!jQuery} $element A photo element
   */
  Gallery.prototype.bindEditPhoto = function($element) {
    var self = this;
    $element.find('.remove').click(function(e) {
      e.stopPropagation();
      self.deletePhoto($element);
      self.broadcast();
    });

    this.bindBrowseGallery($element.find('.photo-image-border'));
  };

  /**
   * Remove a photo from the photos array and hide the element
   *
   * @param {!jQueryElement} $element Photo element to be marked for removal
   */
  Gallery.prototype.deletePhoto = function($element) {
    var photo = yext.location.gallery.photo.ui.getModel($element);

    var index = this.photos.indexOf(photo);
    this.photos.splice(index, 1);

    $element.hide();
    this.presentation();
  };

  /**
   * This triggers and message to indicate when the gallery is updated
   */
  Gallery.prototype.broadcast = function() {
    $(this).trigger('update.gallery');
  };

  /**
   * Bind click events to the photos to open up the gallery
   *
   * @param {!jQuery} $image The image to which to bind the click
   */
  Gallery.prototype.bindBrowseGallery = function($image) {
    var self = this;
    $image.click(function(e) {
      e.stopPropagation();
      _gallery.browse.showGallery(self.displayPhotos, $(this).find('img').attr('src'));
    });
  };

  /**
   * Makes copies of photo objects and strips out unserializable fields
   *
   * @return {!Array} Gallery photos array that can be converted to a JSON string
   */
  Gallery.prototype.photosSerializable = function() {
    var photos = [];

    for (var i = 0; i < this.photos.length; i++) {
      if (this.photos[i].checked !== false) { // Dont include unchecked
        var copy = $.extend(true, {}, this.photos[i]);
        if (copy.asset) {
          // Need to do this because deep copy is not actually deep
          var asset = copy.asset;
          delete copy.asset;

          // Clear other uneeded asset fields
          if (asset.sourceUrl || asset.file) {
            copy.asset = {};

            if (asset.file) {
              copy.asset.fileIndex = asset.fileIndex;
            } else if (asset.sourceUrl) {
              copy.asset.photoUrl = asset.photoUrl;
              copy.asset.sourceUrl = asset.sourceUrl;
            }
          }
        }
        photos.push(copy);
      }
    }
    return photos;
  };

  /**
   * Create a new gallery
   *
   * @param {!jQuery} $element The container for the category searcher and category list
   * @param {string} context The container that this gallery is in
   * @param {boolean} isSuggestEditMode indicates that the user is suggesting on the gallery
   * @return {Gallery} Gallery instance
   */
  _gallery.create = function($element, context, isSuggestEditMode) {
    return new Gallery($element, context, isSuggestEditMode);
  };
});
